module.exports = __webpack_public_path__ + "img/QUNAR.58dfcc34.png";